import { z } from 'zod';

export const inquiryFormSchema = z.object({
  companyName: z
    .string()
    .min(1, 'Company name is required')
    .max(200, 'Company name must be less than 200 characters'),

  contactName: z
    .string()
    .min(1, 'Contact name is required')
    .max(100, 'Contact name must be less than 100 characters'),

  email: z
    .string()
    .min(1, 'Email is required')
    .email('Please enter a valid email address'),

  phoneNumber: z
    .string()
    .max(20, 'Phone number must be less than 20 characters')
    .optional()
    .or(z.literal('')),

  businessType: z
    .string()
    .max(100, 'Business type must be less than 100 characters')
    .optional()
    .or(z.literal('')),

  message: z
    .string()
    .max(2000, 'Message must be less than 2000 characters')
    .optional()
    .or(z.literal('')),
});

export type InquiryFormData = z.infer<typeof inquiryFormSchema>;

export const BUSINESS_TYPES = [
  'Hotel / Resort',
  'Travel Agency',
  'Car Rental Company',
  'Vacation Rental',
  'Airport Service',
  'Tour Operator',
  'Other',
];
